<div class="modal-header">
  <h4 class="col-11 modal-title">
    <img alt="Brand" src="{{directoryImages}}/assets/images/dhl-official2.png">
  </h4>
</div>
<div class="modal-body">
  <h2 style="text-align: center">{{'Shared.TxtModalLoad' | translate}}</h2>
</div>
